import React from "react";
import ReactDOM from "react-dom/client";
import { useEffect, useState } from "react";


const SayGoodBye = (images) => {

    if (images.images) {
        images = images.images;
    }
    const [currentIndex, setCurrentIndex] = useState(0);

    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
        }, 3000); // Change every 5 seconds

        return () => clearInterval(interval); // Cleanup on unmount
    }, [images.length]);

    return (
        // <div class="flex justify-center 
        // lg:w-[50%] xl:w-[50%] md::w-[50%] 
        // max-h-[100vh]
        // md:pad-r-20 lg:pad-r-20 xl:pad-r-20">
        //     <img
        //         src={images[currentIndex]}
        //         alt="Child with backpack"
        //         class="w-[82%]" height="" width="" />
        // </div>
        <img
            src={images[currentIndex]}
            alt="Child with backpack"
            class="w-[82%]" height="" width="" />


    );
};

// ✅ Render React Component in Liquid File
window.renderGoodbyeSlider = (elementid, images) => {

    const rootEl = document.getElementById(elementid);
    if (rootEl) {
        ReactDOM.createRoot(rootEl).render(<SayGoodBye images={images} />);
    }
}
